export default "__VITE_ASSET__CkSAwnS___"